/* import __COLOCATED_TEMPLATE__ from './dashboard-web-mount.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import WritableDOMStream from 'writable-dom';
import * as Sentry from '@sentry/browser';

// The name of the event that is emitted when the application is ready to hydrate.
const APP_READY_EVENT = 'dashboard-web:ready';

// The header that should be used to route to the application.
const APP_HEADER = 'x-dashboard-web';
// The application can only be initialized once in a window context, so it's stored as a module variable.
let app;
export function setApp(app_) {
  app = app_;
}
export function resetApp() {
  app = undefined;
}
function getReactRouter() {
  return window.__reactRouterDataRouter;
}
let isFetchPatched = false;

/**
 * Patches the fetch function so that all React Router requests to the manifest and
 * loaders are sent with the X-Dashboard-Web header so that they are routed properly
 * via tracon.
 */
function patchFetch() {
  if (isFetchPatched) {
    return;
  }
  const originalFetch = window.fetch;
  // eslint-disable-next-line dashboard/use-utilities-window
  window.fetch = (...args) => {
    const request = new Request(...args);
    const url = new URL(request.url);
    if (url.pathname === '/dashboard/__manifest' || url.pathname.endsWith('.data')) {
      request.headers.append('X-Dashboard-Web', 'true');
    }
    return originalFetch(request);
  };
  isFetchPatched = true;
}
let DashboardWebMount = (_class = class DashboardWebMount extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isLoading", _descriptor, this);
    _initializerDefineProperty(this, "isError", _descriptor2, this);
    _defineProperty(this, "root", void 0);
  }
  /**
   * Sets up event listener for module initialization
   */
  waitForAppInitialization() {
    return new Promise((resolve, reject) => {
      window.addEventListener(APP_READY_EVENT, event => {
        const app = event.detail;
        if (app) {
          setApp(app);
          resolve(app);
        } else {
          reject(new Error('Received invalid app data'));
        }
      }, {
        once: true
      });
    });
  }

  /**
   * Streams the application content from a SSR-rendered page into the specified
   * DOM element. Returns a promise that resolves when the application is ready.
   */
  async streamAppToElement(domElement) {
    const appPromise = this.waitForAppInitialization();
    patchFetch();
    const response = await fetch(window.location.href, {
      headers: {
        [APP_HEADER]: 'true'
      }
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch content: ${response.status} ${response.statusText}`);
    }
    const body = response.body;
    if (!body) {
      throw new Error('Response body is null');
    }
    await body.pipeThrough(new TextDecoderStream()).pipeTo(new WritableDOMStream(domElement));
    return appPromise;
  }

  /**
   * Initializes or re-mounts the application.
   */
  async setupApp(domElement) {
    if (app) {
      await getReactRouter()?.navigate(window.location.pathname);
      this.root = await app.renderRoot(domElement);
    } else {
      const app = await this.streamAppToElement(domElement);
      this.root = await app.hydrateRoot(domElement);
    }
  }

  /**
   * Handles and reports mounting errors.
   */
  handleMountError(error) {
    Sentry.captureException(error, {
      tags: {
        feature: 'dashboard-web-mount'
      }
    });
    this.isError = true;
  }
  async mount(domElement) {
    try {
      await this.setupApp(domElement);
    } catch (error) {
      this.handleMountError(error);
    } finally {
      this.isLoading = false;
    }
  }
  teardown() {
    this.root?.unmount();
    this.root = undefined;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "mount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "mount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teardown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "teardown"), _class.prototype), _class);
export { DashboardWebMount as default };